import {
  IterationStatus,
  IterationType,
  ObjectDetectorType,
  ProjectTrainingAdvancedSettingsRequest,
  ProjectType,
} from '@tabeeb/contracts/microservices/swagger-ai-service'
import { AnnotationSource } from '../enums'
import { PagesStatistics } from '../types'

export * from './trainingSettings'

export * from './charts'

export const isAIObjectsSelectionSupported = (projectType: ProjectType): boolean => {
  switch (projectType) {
    case ProjectType.ImageClassification:
    case ProjectType.ObjectDetection:
      return true
    default:
      return false
  }
}

export const isFormSelectionSupported = (projectType: ProjectType): boolean => {
  switch (projectType) {
    case ProjectType.VQA:
      return true
    default:
      return false
  }
}

export const convertToIterationType = (
  annotationSource: AnnotationSource,
  { ObjectDetector }: ProjectTrainingAdvancedSettingsRequest
) => {
  switch (annotationSource) {
    case AnnotationSource.ImageAndQuestionPairs:
      return IterationType.FineTuneCLIP
    case AnnotationSource.ImageAndNlpTagSets:
      return IterationType.ImageNLPClassificationWithPretrainedEncoder
    case AnnotationSource.ImageAndClassificationAnnotations:
      return IterationType.ClassificationWithPretrainedEncoder
    case AnnotationSource.ImageAndBoundingBoxAnnotations:
      switch (ObjectDetector) {
        case ObjectDetectorType.YoloXSmall:
        case ObjectDetectorType.YoloXMedium:
        case ObjectDetectorType.YoloXLarge:
          return IterationType.ObjectDetectionYolox
        default:
          return IterationType.ObjectDetection
      }
    case AnnotationSource.ImageAndPolygonAnnotations:
      return IterationType.InstanceSegmentation
    default:
      throw new Error(`Unknown annotationSource: ${annotationSource}`)
  }
}

export const getIncludesByAnnotationSource = (annotationSource: AnnotationSource) => {
  const result = {
    IncludeTags: false,
    IncludeFormControls: false,
    IncludeAIClassificationAnnotations: false,
    IncludeAIBoundingBoxAnnotations: false,
    IncludeAIPolygonAnnotations: false,
  }

  switch (annotationSource) {
    case AnnotationSource.ImageAndQuestionPairs:
      result.IncludeFormControls = true
      break
    case AnnotationSource.ImageAndNlpTagSets:
      result.IncludeTags = true
      break
    case AnnotationSource.ImageAndClassificationAnnotations:
      result.IncludeAIClassificationAnnotations = true
      result.IncludeAIBoundingBoxAnnotations = true
      result.IncludeAIPolygonAnnotations = true
      break
    case AnnotationSource.ImageAndBoundingBoxAnnotations:
      result.IncludeAIBoundingBoxAnnotations = true
      break
    case AnnotationSource.ImageAndPolygonAnnotations:
      result.IncludeAIPolygonAnnotations = true
      break
    default:
  }

  return result
}

export const getIsIterationCompleted = (iterationStatus: IterationStatus): boolean => {
  return iterationStatus === IterationStatus.Completed
}

export const convertSettingTypeToOptions = <T extends PropertyKey>(
  typeValues: T[],
  displayNameEnum: Record<T, string>
): { id: T; value: string }[] => {
  return typeValues.map((typeValue) => ({
    id: typeValue,
    value: displayNameEnum[typeValue],
  }))
}

export const defaultPagesStatisticsModel: PagesStatistics = {
  Id: null,
  Name: null,

  PagesCountAnnotationBbox: 0,
  PagesCountAnnotationPolygon: 0,
  PagesCountAnnotationClassification: 0,
  PagesCountAnnotationAll: 0,

  ItemsCountAnnotationBbox: 0,
  ItemsCountAnnotationPolygon: 0,
  ItemsCountAnnotationClassification: 0,
  ItemsCountAnnotationAll: 0,

  PagesCountFormQuestions: 0,
  PagesCountNlpTags: 0,
  ItemsCountFormQuestions: 0,
  ItemsCountNlpTags: 0,
}
